<template>
  <div class="result-link-form">
    <div class="result-link-form-title">Поделитесь ссылкой на ваш результат:</div>

    <div v-if="uuid" class="result-link-form-group result-link-form-group--link">
      <input type="text" class="form-input form-input--copy" disabled="disabled" :value="linkUrl">
      <span @click="copyTextToClipboard(linkUrl)"></span>
    </div>

    <div v-else class="result-link-form-group">
      <input type="text" class="form-input" placeholder="Ваше имя (необязательно)" v-model="userName">
      <a href="javascript:void(0)" class="btn btn-blue" @click.prevent="saveResult">{{ submitting ? "Загрузка..." : "Сгенерировать ссылку" }}</a>
      <span></span>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'ShareResultsForm',
    props: {
      testData: {
        type: Object,
        required: true,
      },
      testType: {
        type: String,
        required: true,
      },
      takedTime: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        userName: '',
        submitting: false,
        uuid: '',
      };
    },
    computed: {
      ...mapState('testResult', ['test', 'errors']),
      linkUrl() {
        return this.uuid ? `${window.location.host}/pdd/results/${this.uuid}` : '';
      },
    },
    methods: {
      ...mapActions('testResult', ['saveTestResult']),
      async saveResult() {
        if (this.submitting) return;
        this.submitting = true;

        const data = {
          user_name: this.userName,
          type: this.testType,
          category_id: this.testData.collectionId,
          ticket_id: this.testData.ticketId,
          theme_id: this.testData.themeId,
          payload: {
            answered_questions: this.testData.answeredQuestions,
          },
          results: {
            taked_time: this.takedTime,
            time: this.testData.time,
            questions_count: this.testData.questionsCount,
            correct_answers_count: this.testData.rightCount,
            wrong_answers_count: this.testData.wrongCount,
            passed: this.testData.passed,
            done: this.testData.done,
          },
        };

        const resp = await this.saveTestResult(data);

        if (!Object.keys(this.errors.saveTestResult).length) {
          this.uuid = resp.uuid;
        }

        this.submitting = false;
      },
      copyTextToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);

        textArea.select();

        try {
          const successful = document.execCommand('copy');
          const msg = successful ? 'successful' : 'unsuccessful';
          console.log(`Copying text command was ${msg}`);
        } catch (err) {
          console.log('Oops, unable to copy');
        }

        document.body.removeChild(textArea);
      },
    },
  };
</script>
